import { Col, FormGroup, Row, Text } from '@ksyos/design-system';
import { StyledBorderAndPadding } from '@frontend/components/elements/common';
import { TooV1ProcedureReadOdOsLabel } from './TooV1ProcedureReadOdOsLabel';

interface ITooV1ProcedureSphCylAxReadData {
    as_od: string | null;
    as_os: string | null;
    cylindrisch_od: string | null;
    cylindrisch_os: string | null;
    sferisch_od: string | null;
    sferisch_os: string | null;
}

interface ITooV1ProcedureSphCylAxRead {
    data: ITooV1ProcedureSphCylAxReadData;
    label: string;
}

export function TooV1ProcedureReadSphCylAx({ data, label }: ITooV1ProcedureSphCylAxRead) {
    return (
        <FormGroup label={label}>
            <Row columnGap={[2, 4, 6]}>
                <Col span={[12, 6, null, null, 4]}>
                    <StyledBorderAndPadding>
                        <TooV1ProcedureReadOdOsLabel side="OD" />
                        <Row columnGap={2}>
                            <Col span={4}>
                                <Text size="xs">S {data.sferisch_od}</Text>
                            </Col>
                            <Col span={4}>
                                <Text size="xs">C {data.cylindrisch_od}</Text>
                            </Col>
                            <Col span={4}>
                                <Text size="xs">as {data.as_od}</Text>
                            </Col>
                        </Row>
                    </StyledBorderAndPadding>
                </Col>
                <Col span={[12, 6, null, null, 4]}>
                    <StyledBorderAndPadding>
                        <TooV1ProcedureReadOdOsLabel side="OS" />
                        <Row columnGap={2}>
                            <Col span={4}>
                                <Text size="xs">S {data.sferisch_os}</Text>
                            </Col>
                            <Col span={4}>
                                <Text size="xs">C {data.cylindrisch_os}</Text>
                            </Col>
                            <Col span={4}>
                                <Text size="xs">as {data.as_os}</Text>
                            </Col>
                        </Row>
                    </StyledBorderAndPadding>
                </Col>
            </Row>
        </FormGroup>
    );
}
